import React from 'react';

const JurisdictionsDisclaimers = () => (
	<div className="container main">
		<h2>면책사항</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>캐나다</h4>
				<p>
					캐나다의 리콜 통지 범위는 캐나다 소비자제품안전법(Canada Consumer Product Safety Act, CCPSA)에 따라
					"포장을 포함하여, 개인이 가정용, 오락용 및 스포츠용을 비롯한 비상업적 목적으로 사용하기 위해 획득할 것이라 합리적으로 기대될 수 있는 구성 요소, 부품 또는 부속품을 포함한 제품"
					으로 정의된 소비재를 대상으로 합니다.
				</p>
				<p>
					여기에는 화장품도 포함됩니다. "화장품"이라는 용어는 식품의약품법(FDA)에 따라
					"얼굴 피부, 신체 피부, 모발 또는 치아를 청결하게 하거나 개선하거나 변화시키기 위한 목적으로 제조, 판매 또는 사용되는 물질 또는 혼합물로 정의되며 데오도란트와 향수가 이에 포함된다"
					라고 정의합니다.
				</p>
				<p>캐나다 소비재 및 화장품 리콜 통지 범위에 속하지 않는 분야는 다음과 같습니다.</p>
				<ul>
					<li>폭발물법(Explosives Act) 제2조에 규정된 폭발물.</li>
					<li>식품의약품법(Food and Drugs Act) 제2조에 규정된 기기.</li>
					<li>식품의약품법(Food and Drugs Act) 제2조에 규정된 약품.</li>
					<li>해충방제제품에 대한 법률(Pest Control Products Act) 제2항1호에 규정된 해충방제제품.</li>
					<li>차량안전법(Motor Vehicle Safety Act) 제2조에 규정된 차량 및 최초 소매 구매자에게 판매되기 전에 조립되거나 개조되는 경우 그에 포함된 차량 부품으로서, 그러한 부품을 교체하거나 개조하는 차량의 부품 포함.</li>
					<li>사료법(Feeds Act) 제2조에 규정된 사료.</li>
					<li>비료법(Fertilizers Act) 제2조에 규정된 비료.</li>
					<li>캐나다 선박법(Shipping Act, 2001) 제2조에 규정된 선박.</li>
					<li>형법(Criminal Code) 제2조에 규정된 화기.</li>
					<li>형법(Criminal Code) 제84항1호에 규정된 탄약.</li>
					<li>형법(Criminal Code) 제84항1호에 규정된 카트리지 탄창.</li>
					<li>형법(Criminal Code) 제84항1호에 규정된 석궁.</li>
					<li>형법(Criminal Code) 제84항1호의 '금지된 기기' 정의에서 (a)부터 (d)까지 규정된 금지된 기기.</li>
					<li>로자리콩(홍두)을 제외한 식물보호법(Plant Protection Act) 제3조에 규정된 식물.</li>
					<li>로자리콩(홍두)을 제외한 종자법(Seeds Act) 제2조에 규정된 종자.</li>
					<li>규제 약물 및 물질에 관한 법(Controlled Drugs and Substances Act) 제2항1호에 규정된 규제 물질.</li>
					<li>항공법(Aeronautics Act) 제3항1호에 규정된 항공 제품.</li>
					<li>동물보건법(Health of Animals Act) 제2항1호에 규정된 동물.</li>
				</ul>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>유럽연합 집행위원회(European Commission)</h4>
				<p>안전 게이트 / RAPEX 경고에 명시되지 않은 위험은 소비자의 건강과 안전에 대한 위험을 의미합니다.</p>
				<p>2010년부터 경고에는 전문 비식품 제품 및 보안 위험이나 환경에 대한 위험과 같은 기타 위험을 초래하는 비식품 제품에 대해 취해진 조치도 포함됩니다.</p>
				<p>2019년부터는 이전에 국가 당국 간에 정보용으로만 배포되었던 경고가 국가 당국에서 필요하다고 판단되는 경우 웹사이트에도 게시됩니다.</p>
				<p>이 목록에 표시되는 독점 브랜드, 디자인 및 로고는 경제 운영자가 지적 재산권을 침해하여 적법한 소유자의 지식 및/또는 허가 없이 사용했을 수 있습니다.</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>일본</h4>
				<p>리콜 통지 범위에는 가전제품, 가정용품, 문구 및 엔터테인먼트 제품 등이 포함되며 식품, 차량 및 의약품(화장품 포함)은 제외됩니다.</p>
			</div>
		</div>
		<hr/>

		<div className="row">
			<div className="col-sm-12">
				<h4>미국</h4>
				<p>
					미 소비자제품안전위원회(Consumer Product Safety Commission)는 커피메이커, 장난감, 잔디 깎는 기계, 폭죽 등 다양한 유형의 소비재를 관할합니다.
					그러나 일부 소비재 유형은 다른 연방 기관이 담당합니다.
					다른 기관의 관할 제품 목록은 다음 링크에서 확인하시기 바랍니다.
					<a href="https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/" target="_blank">https://www.cpsc.gov/Regulations-Laws--Standards/Products-Outside-CPSCs-Jurisdiction/</a>.
				</p>
			</div>
		</div>
		<hr/>
	</div>
);

export default JurisdictionsDisclaimers ;



// WEBPACK FOOTER //
// ./src/views/static/ko/jurisdictions-disclaimers.js